import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import feeds from '../apis/feeds';
import FeedComponent from './FeedComponent';
import Loader from './Loader';
import NotFound from './NotFound';
import { ThemeContext } from '../context/themeContext';

const Home = () => {
  const [feedData, setFeedData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const { theme } = React.useContext(ThemeContext);
  const isDarkTheme = theme === 'dark';
  useEffect(() => {
    feeds
      .get('/mostpopular/v2/viewed/7.json')
      .then((response) => {
        setLoader(false);
        setError(false);
        setFeedData(response.data.results);
      })
      .catch((errorData) => {
        setLoader(false);
        setError(true);
        console.error('Error in Home.useEffect.getFeed API', errorData);
        setFeedData([]);
      });
  }, []);
  return (
    <section
      className={classNames(
        'body-font overflow-hidden',
        { 'text-gray-600': !isDarkTheme },
        { 'text-gray-400 bg-gray-900': isDarkTheme },
      )}
    >
      <div className="container px-5 py-6 mx-auto">
        {loader && <Loader isDarkTheme={isDarkTheme} />}
        <div
          className={classNames(
            '-my-8 divide-y-2 ',
            { 'divide-gray-100': !isDarkTheme },
            { 'divide-gray-800': isDarkTheme },
          )}
        >
          {feedData.map((feed) => {
            return (
              <FeedComponent
                key={feed.id}
                feedUrl={feed.url}
                title={feed.title}
                description={feed.abstract}
                type={feed.type}
                section={feed.section}
                imageUrl={
                  feed.media?.[0]?.['media-metadata']?.[2]?.url ||
                  'https://source.unsplash.com/user/erondu/440x293'
                }
                publishDate={feed.published_date}
                updatedDate={feed.updated}
                byline={feed.byline}
                isDarkTheme={isDarkTheme}
              />
            );
          })}
          {error && !loader && <NotFound isDarkTheme={isDarkTheme} error={error} />}
        </div>
      </div>
    </section>
  );
};

export default Home;
